import { CodebookModel } from 'app/shared/model/shared.model';
import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';
import { AddressModel, initialAddress } from 'app/shared/address-input/model/address.model';
import { partyTypes } from 'app/shared/enumeration/enums';

export interface PartiesModel {
  idCase: string;
  partyNumber: CodebookModel[];
  partyFileInsight: CodebookModel[];
  partyFileInsightExplanation: string;
}

export const initialPartiesData = {
  partyNumber: [],
  partyFileInsight: [],
  partyFileInsightExplanation: '',
};

export interface PartyModel {
  idParty?: number;
  partyType?: CodebookModel[];
  subjectType?: CodebookModel[];
  person: PersonModel;
  legalEntity: LegalEntityModel;
  email?: string;
  phoneNumber?: string;
  telephoneNumber?: string;
  partyAddress: AddressModel;
  parties: CodebookModel[];
  procurationType: CodebookModel[];
  procurationStatus: boolean;
  fileInsight?: CodebookModel[];
  partyFeature?: CodebookModel[];
  cadastralParticle?: string;
  insightStatement?: string;
}

export interface PartyView {
  idParty: number;
  name: string;
  oibMb: string;
  partyType: string;
  address: string;
  email: string;
  fileInsight: string;
  hasAssigneeLinkedOnlyToThisParty: boolean;
}

export const partyInitialData = {
  partyType: [partyTypes[0]],
  email: '',
  telephoneNumber: '+385',
  subjectType: [],
  person: {
    oib: '',
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    address: null,
    subjectType: null,
  },
  legalEntity: {
    oib: '',
    mb: '',
    address: null,
    companyName: '',
    subjectType: null,
  },
  partyAddress: initialAddress,
  parties: [],
  procurationType: [],
  procurationStatus: true,
  fileInsight: [],
  partyFeature: [],
  cadastralParticle: '',
  insightStatement: '',
};
